import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { FaturamentoComponent } from './components/minha-conta/faturamento/faturamento.component';
import { TransacoesComponent } from './components/transacoes/transacoes.component';
import { CobrancasPixComponent } from './components/cobrancas-pix/cobrancas-pix.component';
import { MinhaContaComponent } from './components/minha-conta/minha-conta.component';
import { ConfiguracoesComponent } from './components/minha-conta/configuracoes/configuracoes.component';
import { VisaoGeralComponent } from './components/visao-geral/visao-geral.component';
import { AuthGuardService } from '../../shared/services/auth-guard/auth-guard.service';
import { BoletosComponent } from './components/boletos/boletos.component';
import { RemessaComponent } from './components/boletos/remessa/remessa.component';
import { RetornoComponent } from './components/boletos/retorno/retorno.component';
import { NFSeComponent } from './components/nfse/nfse.component';
import { ClientesComponent } from './components/clientes/clientes/clientes.component';
import { ClienteComponent } from './components/clientes/cliente/cliente.component';
import { TodosBoletosComponent } from './components/boletos/todos-boletos/todos-boletos.component';
import { LancamentosFuturosComponent } from './components/minha-conta/lancamentos-futuros/lancamentos-futuros.component';
import { AgendaFinanceiraComponent } from './components/agenda-financeira/agenda-financeira.component';
import { VendasComponent } from './components/vendas/vendas.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: DashboardComponent,
    children: [
      {
        path: 'transacoes',
        component: TransacoesComponent,
        data: { title: 'Transações', breadcrumb: 'Transações', link: '/transacoes' }
      },
      {
        path: 'cobrancas-pix',
        component: CobrancasPixComponent,
        data: { title: 'PIX', breadcrumb: 'PIX', link: '/cobrancas-pix' }
      },
      {
        path: 'vendas',
        component: VendasComponent,
        data: { title: 'Vendas', breadcrumb: 'Vendas', link: '/vendas' }
      },
      {
        path: 'agenda-financeira',
        component: AgendaFinanceiraComponent,
        data: { title: 'Agenda Financeira', breadcrumb: 'Agenda Financeira', link: '/agenda-financeira' }
      },
      {
        path: 'nfse',
        component: NFSeComponent,
        data: { title: 'NFS-e', breadcrumb: 'NFS-e', link: '/nfse' }
      },
      {
        path: 'visao-geral',
        component: VisaoGeralComponent,
        data: { title: 'Visão Geral', breadcrumb: 'Visão Geral', link: '/visao-geral' }
      },
      {
        path: 'minha-conta',
        component: MinhaContaComponent,
        data: { title: 'Minha Conta', breadcrumb: 'Minha Conta', link: '/minha-conta/configuracoes' },
        children: [
          // {
          //   path: 'faturamento',
          //   component: FaturamentoComponent,
          //   data: { title: 'Faturamento', breadcrumb: 'Faturamento', link: '/minha-conta/faturamento' }
          // },
          {
            path: 'lancamentos-futuros',
            component: LancamentosFuturosComponent,
            data: { title: 'Lançamentos Futuros', breadcrumb: 'Lançamento Futuros', link: '/minha-conta/lancamentos-futuros' }
          },
          {
            path: 'configuracoes',
            component: ConfiguracoesComponent,
            data: { title: 'Configurações', breadcrumb: 'Configurações', link: '/minha-conta/configuracoes' }
          },
        ]
      },
      {
        path: 'boletos',
        component: BoletosComponent,
        data: { title: 'Boletos', breadcrumb: 'Boletos', link: '/boletos/remessa' },
        children: [
          {
            path: 'todos-boletos',
            component: TodosBoletosComponent,
            data: { title: 'Boletos', breadcrumb: 'Todos Boletos', link: '/boletos/todos-boletos' }
          },
          {
            path: 'remessa',
            component: RemessaComponent,
            data: { title: 'Remessa', breadcrumb: 'Remessa', link: '/boletos/remessa' }
          },
          {
            path: 'retorno',
            component: RetornoComponent,
            data: { title: 'Retorno', breadcrumb: 'Retorno', link: '/boletos/retorno' }
          },
        ]
      },
      {
        path: 'clientes',
        component: ClientesComponent,
        data: { title: 'Clientes', breadcrumb: 'Clientes', link: '/clientes' }
      },
      {
        path: 'cliente/:id',
        component: ClienteComponent,
        data: { title: 'Cliente', breadcrumb: 'Cliente', link: '/cliente' }
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
  ],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
